export default "__VITE_ASSET__DlvYU84r__"